// @flow
import React from "react";
import { useSelector } from "react-redux";

import { Translate } from "@quantum/i18n";

import {
  SelecaoCasasDecimais,
  SelecaoTipoConta,
  SelecaoVersaoConta,
  SelecaoFormaAcumulacao,
  SelecaoPeriodoIndicadoresFinanceiros,
  SelecaoToleranciaDF,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import SelecaoFrequencia from "../configuracoes/periodos/indicadoresFinanceiros/SelecaoFrequencia";

export const processarAcumulacao = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      tipoConta: edicaoMedida.tipoConta,
      versaoConta: edicaoMedida.versaoConta,
      formaAcumulacao: edicaoMedida.formaAcumulacao,
      toleranciaDF: edicaoMedida.toleranciaDF,
      dataBase: dataBase,
      ajusteDias: edicaoMedida.ajusteDias,
      frequencias: edicaoMedida.frequencias,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      tipoConta: edicaoMedida.tipoConta,
      versaoConta: edicaoMedida.versaoConta,
      formaAcumulacao: edicaoMedida.formaAcumulacao,
      toleranciaDF: edicaoMedida.toleranciaDF,
      dataBase: dataBase,
      ajusteDias: edicaoMedida.ajusteDias,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

export default function Acumulacao() {
  const modoSeries = useSelector(isModoSeries);

  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <div className="ConfiguracaoMedida__box">
            <SelecaoToleranciaDF />
          </div>

          <div className="ConfiguracaoMedida__box">
            <SelecaoFrequencia />
          </div>
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoFormaAcumulacao />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <SelecaoPeriodoIndicadoresFinanceiros />
        <div className="ConfiguracaoMedida__vertical-divider" />
        <div className="ConfiguracaoMedida">
          <h3 className="ConfiguracaoMedida__group-title">
            <Translate>configuracaoRelatorio.parametros</Translate>
          </h3>
          <div className="ConfiguracaoMedida__group--grey">
            <div className="ConfiguracaoMedida__box">
              <SelecaoTipoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoVersaoConta />
            </div>
            <div className="ConfiguracaoMedida__box">
              <SelecaoFormaAcumulacao />
            </div>
          </div>
        </div>
        <div className="ConfiguracaoMedida__vertical-divider" />
        <SelecaoCasasDecimais />
      </>
    );
  }
}
